import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function SelectionIcon() {
    const { target } = useBoundContext()
    if (!target.newCategoryId) return null
    return <Iconify icon="eva:folder-fill" sx={{ color: "warning.main", width: 20, height: 20, mr: 1 }} />
}
